/**
 * Browser-safe identity marker shared by Express and the web client.
 * A synthetic UID identifies the credential, never the customer data owner.
 * The prefix identifies sessions that require validation; it grants no access.
 * Keep this wire format aligned with Firestore rules and the ws-tiptap reader.
 */
export const ADMIN_SESSION_UID_PREFIX = "admin-session:";

export function isAdminSessionUid(uid) {
  return typeof uid === "string" && uid.startsWith(ADMIN_SESSION_UID_PREFIX);
}
